/* Sentinel wire range (docs/sentinel-wire/03): product page (format table, add to cart, calculator,
   sticky bar) and collection page (project tiles, filters, sort, comparison columns, calculator).
   No dependencies. Cart: /cart/add.js then the theme drawer (same pattern as assets/sentinel-pdp.js). */
(function () {
  'use strict';
  if (window.__swInit) return;
  window.__swInit = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  function t(fr, en) { return EN ? en : fr; }
  var NB = ' ';

  function money(cents, fmt) {
    var d = (Math.round(cents) / 100).toFixed(2);
    fmt = fmt || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, d.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, d)
      .replace(/<[^>]+>/g, '');
  }
  function heightLabel(inches, inchOnly) {
    if (!inches) return '';
    if (!inchOnly && inches % 12 === 0) return (inches / 12) + ' ' + t('pi', 'ft');
    return inches + ' ' + t('po', 'in');
  }
  function kgLabel(g) {
    if (!g) return t('À confirmer', 'To be confirmed');
    var k = (Math.round(g / 100) / 10).toFixed(1);
    return (EN ? k : k.replace('.', ',')) + ' kg';
  }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- Cart ---------- */
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      var link = document.getElementById('cart-icon-bubble');
      if (link) link.click();
      return Promise.resolve();
    }
    drawer.classList.remove('is-empty');
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); })
      .catch(function () { var l = document.getElementById('cart-icon-bubble'); if (l) l.click(); });
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && (j.description || j.message) || 'error');
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        return openDrawer().then(function () { return j; });
      });
    });
  }

  /* ---------- Calculator: cheapest set of in-stock rolls covering the length ---------- */
  function planRolls(variants, height, length) {
    var rolls = variants.filter(function (v) { return v.available && v.h === height && v.l > 0; });
    if (!rolls.length || !(length > 0)) return null;
    var g = 5;
    rolls.forEach(function (v) { if (v.l % 5 !== 0) g = 1; });
    var target = Math.ceil(length / g), maxL = 0;
    rolls.forEach(function (v) { maxL = Math.max(maxL, v.l / g); });
    var top = target + maxL, cost = [0], pick = [null], count = [0];
    for (var s = 1; s <= top; s++) {
      cost[s] = Infinity; pick[s] = null; count[s] = 0;
      for (var i = 0; i < rolls.length; i++) {
        var li = rolls[i].l / g;
        var from = Math.max(0, s - li);
        if (cost[from] === Infinity) continue;
        var c = cost[from] + rolls[i].price, n = count[from] + 1;
        if (c < cost[s] || (c === cost[s] && n < count[s])) { cost[s] = c; pick[s] = [i, from]; count[s] = n; }
      }
    }
    var best = -1;
    for (var s2 = target; s2 <= top; s2++) {
      if (cost[s2] === Infinity) continue;
      if (best < 0 || cost[s2] < cost[best] || (cost[s2] === cost[best] && count[s2] < count[best])) best = s2;
    }
    if (best < 0) return null;
    var qty = {}, cur = best;
    while (cur > 0 && pick[cur]) { var k = pick[cur][0]; qty[k] = (qty[k] || 0) + 1; cur = pick[cur][1]; }
    var lines = Object.keys(qty).map(function (k) { return { v: rolls[k], q: qty[k] }; })
      .sort(function (a, b) { return b.v.l - a.v.l; });
    var total = 0, covered = 0;
    lines.forEach(function (x) { total += x.v.price * x.q; covered += x.v.l * x.q; });
    return { lines: lines, total: total, covered: covered };
  }
  function postsFor(tpost, spacing, heightIn, length) {
    if (!tpost || !spacing || !(length > 0)) return null;
    var ft = heightIn / 12, want = ft <= 4 ? "6'" : (ft <= 5 ? "7'" : "8'");
    var v = null;
    tpost.variants.forEach(function (x) { if (!v && x.title.replace(/\s/g, '').indexOf(want) === 0) v = x; });
    if (!v || !v.available) return null;
    // Same rule as the install step: one post every spacing, plus two.
    return { v: v, q: Math.ceil(length / spacing) + 2, title: tpost.title };
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function firstAvail(p) { if (!p) return null; for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i]; return null; }

  /* ---------- Installation kit (product page) ---------- */
  function initKit(root, data, getCurrent, fmt) {
    var box = $('[data-sw-kit]', root);
    if (!box) return function () {};
    var len = $('[data-sw-kit-len]', box), rowsEl = $('[data-sw-kit-rows]', box), forEl = $('[data-sw-kit-for]', box);
    var totalEl = $('[data-sw-kit-total]', box), wasEl = $('[data-sw-kit-was]', box), saveEl = $('[data-sw-kit-save]', box);
    var add = $('[data-sw-kit-add]', box), off = {}, rows = [], now = 0;
    var unit = t('pi', 'ft');
    function render() {
      var v = getCurrent(), H = v && v.h, L = parseInt(len.value, 10);
      rows = [];
      if (!(L > 0) || !H) { rowsEl.innerHTML = ''; forEl.textContent = ''; add.disabled = true; totalEl.textContent = ''; return; }
      forEl.textContent = t('Pour ', 'For ') + L + NB + unit + t(' de clôture, ', ' of fence, ') + heightLabel(H, data.inch) + t(' de haut', ' high');
      var plan = planRolls(data.variants, H, L);
      if (!plan) {
        rowsEl.innerHTML = '<li class="sw-kit__msg">' + t('Aucun rouleau en stock à cette hauteur pour le moment.', 'No roll in stock at this height right now.') + '</li>';
        add.disabled = true; totalEl.textContent = ''; wasEl.hidden = true; saveEl.hidden = true; return;
      }
      plan.lines.forEach(function (x) {
        rows.push({ key: 'roll' + x.v.id, fixed: true, id: x.v.id, q: x.q, unit: x.v.price, img: data.img,
          title: t('Rouleau ', 'Roll ') + x.v.title, sub: x.q + ' x ' + money(x.v.price, fmt) });
      });
      var posts = postsFor(data.tpost, data.spacing, H, L);
      if (posts) rows.push({ key: 'tpost', id: posts.v.id, q: posts.q, unit: posts.v.price, img: data.tpost.img, title: data.tpost.title,
        sub: posts.v.title + ' · ' + posts.q + ' x ' + money(posts.v.price, fmt) + ' · ' + t('un tous les ', 'one every ') + data.spacing + NB + unit + t(', plus deux', ', plus two') });
      var tv = firstAvail(data.tie);
      if (tv) { var tq = Math.max(1, Math.ceil(L / 100)); rows.push({ key: 'tie', id: tv.id, q: tq, unit: tv.price, img: data.tie.img, title: data.tie.title, sub: tq + ' x ' + money(tv.price, fmt) }); }
      var dv = firstAvail(data.driver);
      if (dv) rows.push({ key: 'driver', id: dv.id, q: 1, unit: dv.price, img: data.driver.img, title: data.driver.title, sub: t('Si vous n\'en avez pas', 'If you do not have one') });
      var rollTotal = 0, accTotal = 0;
      rowsEl.innerHTML = rows.map(function (r) {
        var line = r.unit * r.q;
        if (r.fixed) rollTotal += line; else if (!off[r.key]) accTotal += line;
        return '<li class="sw-kit__row' + (off[r.key] ? ' is-off' : '') + '">' +
          (r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy" width="48" height="48">' : '<span></span>') +
          '<span><b>' + esc(r.title) + '</b><small>' + esc(r.sub) + '</small></span>' +
          '<span class="sw-kit__price">' + money(line, fmt) + '</span>' +
          (r.fixed ? '<span></span>' : '<button type="button" class="sw-kit__x" data-sw-kit-x="' + r.key + '" aria-pressed="' + (off[r.key] ? 'true' : 'false') + '" aria-label="' +
            (off[r.key] ? t('Remettre ', 'Put back ') : t('Retirer ', 'Remove ')) + esc(r.title) + '">' + (off[r.key] ? '+' : '×') + '</button>') + '</li>';
      }).join('');
      var pct = +data.kitPct || 0, saving = pct > 0 ? Math.round(accTotal * pct / 100) : 0;
      now = rollTotal + accTotal - saving;
      totalEl.textContent = money(now, fmt);
      wasEl.hidden = !saving; if (saving) wasEl.textContent = money(rollTotal + accTotal, fmt);
      saveEl.hidden = !saving; if (saving) saveEl.textContent = t('Vous économisez ', 'You save ') + money(saving, fmt) + t(' sur le kit', ' on the kit');
      add.disabled = false;
      add.textContent = t('Ajouter les rouleaux et le kit', 'Add the rolls and the kit') + ' · ' + money(now, fmt);
    }
    len.addEventListener('input', render);
    $$('[data-sw-kit-step]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        len.value = Math.max(25, (parseInt(len.value, 10) || 0) + parseInt(b.getAttribute('data-sw-kit-step'), 10)); render();
      });
    });
    rowsEl.addEventListener('click', function (e) {
      var x = e.target.closest('[data-sw-kit-x]'); if (!x) return;
      var k = x.getAttribute('data-sw-kit-x'); off[k] = !off[k]; render();
    });
    add.addEventListener('click', function () {
      var items = rows.filter(function (r) { return r.fixed || !off[r.key]; }).map(function (r) { return { id: r.id, quantity: r.q }; });
      if (!items.length) return;
      add.disabled = true;
      addItems(items).catch(function (err) {
        var m = document.createElement('p'); m.className = 'sw-kit__msg'; m.textContent = err.message; add.after(m);
        setTimeout(function () { m.remove(); }, 6000);
      }).then(function () { add.disabled = false; });
    });
    render();
    return render;
  }
  function bindCalc(box, getData, fmt) {
    if (!box) return;
    var len = $('[data-sw-calc-len]', box), hSel = $('[data-sw-calc-h]', box);
    var out = $('[data-sw-calc-out]', box), actions = $('[data-sw-calc-actions]', box), add = $('[data-sw-calc-add]', box);
    var plan = null, posts = null;
    function render() {
      var d = getData(); if (!d) return;
      var L = parseInt(len.value, 10), H = parseInt(hSel.value, 10);
      plan = planRolls(d.variants, H, L);
      posts = plan ? postsFor(d.tpost, d.spacing, H, L) : null;
      if (!(L > 0)) { out.hidden = true; actions.hidden = true; return; }
      if (!plan) {
        out.innerHTML = t('Aucun rouleau en stock à cette hauteur pour le moment.', 'No roll in stock at this height right now.');
        out.hidden = false; actions.hidden = true; return;
      }
      var unit = t('pi', 'ft');
      var html = '<b>' + plan.lines.map(function (x) { return x.q + ' x ' + x.v.l + NB + unit; }).join(' + ') +
        '</b> ' + t('de', 'at') + ' ' + heightLabel(H, d.inch) + ' : ' + plan.covered + NB + unit + t(' pour ', ' for ') + L + NB + unit +
        '<br>' + t('Rouleaux', 'Rolls') + ' : ' + money(plan.total, fmt);
      if (posts) {
        html += '<ul><li><label><input type="checkbox" data-sw-calc-posts checked> ' + posts.q + ' ' + t('poteaux en T', 'T-posts') +
          ' ' + posts.v.title + ' (' + t('un tous les ', 'one every ') + d.spacing + NB + unit + t(', plus un', ', plus one') + ') : ' +
          money(posts.v.price * posts.q, fmt) + '</label></li></ul>';
      }
      out.innerHTML = html; out.hidden = false; actions.hidden = false;
    }
    len.addEventListener('input', render);
    hSel.addEventListener('change', render);
    box.__swRender = render;
    add.addEventListener('click', function () {
      if (!plan) return;
      var items = plan.lines.map(function (x) { return { id: x.v.id, quantity: x.q }; });
      var cb = $('[data-sw-calc-posts]', box);
      if (posts && cb && cb.checked) items.push({ id: posts.v.id, quantity: posts.q });
      add.disabled = true;
      addItems(items).catch(function (e) { out.innerHTML += '<br><span style="color:#a20901">' + e.message + '</span>'; })
        .then(function () { add.disabled = false; });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var data = readJSON($('[data-sw-data]', root)); if (!data) return;
    var fmt = data.money;
    var byId = {}; data.variants.forEach(function (v) { byId[v.id] = v; });
    var idInput = $('[data-sw-id]', root), atc = $('[data-sw-atc]', root), form = $('[data-sw-form]', root);
    var msg = $('[data-sw-msg]', root), bar = $('[data-sw-bar]', root);
    var current = byId[idInput.value];

    // Gallery: thumbnails on wide screens; on phones the photos scroll in a row and a counter follows.
    var slides = $$('[data-sw-slide]', root);
    $$('[data-sw-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-sw-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-sw-slide') === i); });
        $$('[data-sw-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
    var track = $('[data-sw-gal-track]', root), counter = $('[data-sw-gal-i]', root);
    if (track && counter && slides.length > 1) {
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = null;
          var w = slides[0].getBoundingClientRect().width + 8;
          counter.textContent = Math.min(slides.length, Math.round(track.scrollLeft / w) + 1);
        });
      }, { passive: true });
    }

    // "Toutes les spécifications" opens by itself on wide screens.
    if (window.matchMedia('(min-width: 900px)').matches) $$('[data-sw-open-wide]').forEach(function (d) { d.open = true; });

    var kitRender = function () {};
    function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }
    function select(v) {
      if (!v) return;
      current = v;
      idInput.value = v.id;
      $$('[data-sw-variant]', root).forEach(function (c) { c.setAttribute('aria-pressed', String(+c.getAttribute('data-sw-variant') === v.id)); });
      setText('[data-sw-price]', money(v.price, fmt));
      setText('[data-sw-bar-price]', money(v.price, fmt));
      setText('[data-sw-fmt-current]', v.title);
      setText('[data-sw-bar-fmt]', v.title);
      var ppf = $('[data-sw-ppf]', root);
      if (ppf) { if (v.l) { ppf.hidden = false; ppf.textContent = money(Math.round(v.price / v.l), fmt) + ' / ' + t('pi', 'ft'); } else ppf.hidden = true; }
      var unit = $('[data-sw-unit]', root);
      if (unit && v.l) unit.textContent = v.h ? t('Rouleau de ', 'Roll ') + heightLabel(v.h, data.inch) + ' x ' + v.l + ' ' + t('pi', 'ft') : t('Bobine de ', 'Coil, ') + v.l + ' ' + t('pi', 'ft');
      var stock = $('[data-sw-stock]', root);
      if (stock) {
        stock.className = 'sw-stock ' + (v.available ? 'sw-stock--ok' : 'sw-stock--out');
        stock.textContent = v.available ? t('En stock', 'In stock') : t('Ce format est en rupture de stock', 'This format is out of stock');
      }
      atc.disabled = !v.available;
      atc.textContent = v.available ? t('Ajouter au panier', 'Add to cart') : t('Rupture de stock', 'Out of stock');
      var barAdd = $('[data-sw-bar-add]', root); if (barAdd) barAdd.disabled = !v.available;
      if (v.h) setText('[data-sw-spec-h]', heightLabel(v.h, data.inch));
      if (v.l) setText('[data-sw-spec-l]', v.l + ' ' + t('pi', 'ft'));
      setText('[data-sw-spec-w]', kgLabel(v.g));
      kitRender();
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    }
    $$('[data-sw-variant]', root).forEach(function (c) {
      c.addEventListener('click', function () { select(byId[c.getAttribute('data-sw-variant')]); });
    });

    // Quantity
    var q = $('[data-sw-qty-input]', root);
    $$('[data-sw-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-sw-qty'), 10)); });
    });

    // Add to cart
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      atc.disabled = true; msg.hidden = true;
      addItems([{ id: current.id, quantity: Math.max(1, parseInt(q.value, 10) || 1) }])
        .catch(function (err) { msg.textContent = err.message; msg.className = 'sw-msg is-error'; msg.hidden = false; })
        .then(function () { atc.disabled = !current.available; });
    });

    // Installation kit, sized on the selected height and the length to fence.
    kitRender = initKit(root, data, function () { return current; }, fmt);

    // Project cards: "Format conseillé" selects that format and brings the format table into view.
    root.__swSelect = function (id) { select(byId[id]); };

    // Sticky bar: only after the add button has scrolled above the screen; above the theme's bottom nav while it shows.
    if (bar) {
      document.body.appendChild(bar);
      var nav = document.querySelector('.bottom-nav');
      var lift = function () {
        var h = 0;
        if (nav) { var cs = getComputedStyle(nav); if (!nav.classList.contains('bottom-nav--hidden') && cs.display !== 'none' && cs.visibility !== 'hidden') h = Math.ceil(nav.getBoundingClientRect().height); }
        bar.style.setProperty('--sw-bar-lift', h + 'px');
      };
      var check = function () { var past = atc.getBoundingClientRect().bottom < 0; bar.setAttribute('data-visible', String(past)); bar.setAttribute('aria-hidden', String(!past)); };
      lift(); check();
      if (nav && window.MutationObserver) new MutationObserver(lift).observe(nav, { attributes: true, attributeFilter: ['class', 'style'] });
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', function () { lift(); check(); });
      $('[data-sw-bar-add]', bar).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : atc.click(); });
    }
  }

  /* ---------- Project card format buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sw-pick]');
    if (!b) return;
    var root = document.querySelector('[data-sw-product]');
    if (!root || !root.__swSelect) return;
    root.__swSelect(+b.getAttribute('data-sw-pick'));
    var to = document.getElementById('sw-formats') || root;
    var y = to.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  });

  /* ---------- Quick add (Pour l'installer) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sw-quick]');
    if (!b) return;
    b.disabled = true;
    addItems([{ id: +b.getAttribute('data-sw-quick'), quantity: 1 }]).catch(function () {}).then(function () { b.disabled = false; });
  });

  /* ---------- Collection page ---------- */
  function openingLabel(mm) {
    var inch = mm / 25.4, map = [[0.125, '1/8'], [0.25, '1/4'], [0.5, '1/2'], [0.75, '3/4']];
    for (var i = 0; i < map.length; i++) if (Math.abs(inch - map[i][0]) < 0.02) return map[i][1] + ' ' + t('po', 'in');
    return (Math.round(inch * 10) / 10) + ' ' + t('po', 'in');
  }
  function initCollection(root) {
    var data = readJSON($('[data-sw-coll-data]', root)) || { products: {} };
    var fmt = data.money;
    var grid = $('[data-sw-grid]', root), cards = $$('[data-sw-card]', root);
    var state = { projet: '', type: [], h: [], o: [], stock: false };
    var advice = $('[data-sw-advice]', root), count = $('[data-sw-count]', root), empty = $('[data-sw-empty]', root);

    // Height and opening chips from the cards on the page.
    var hs = {}, os = {};
    cards.forEach(function (c) {
      c.getAttribute('data-h').split('|').forEach(function (h) { if (h) hs[h] = hs[h] || c.getAttribute('data-inch') === 'true'; });
      var o = c.getAttribute('data-open'); if (o) os[o] = true;
    });
    function addChip(group, key, val, label) {
      var g = $('[data-sw-group="' + group + '"]', root); if (!g) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sw-chip'; b.setAttribute('aria-pressed', 'false');
      b.setAttribute('data-sw-f', key); b.setAttribute('data-v', val); b.textContent = label;
      g.appendChild(b);
    }
    Object.keys(hs).map(Number).sort(function (a, b) { return a - b; }).forEach(function (h) { addChip('h', 'h', String(h), heightLabel(h, hs[h] && h % 12 !== 0)); });
    Object.keys(os).map(Number).sort(function (a, b) { return a - b; }).forEach(function (o) { addChip('o', 'o', String(o), openingLabel(o)); });
    $$('[data-sw-group]', root).forEach(function (g) { if (g.children.length < 3) g.hidden = true; });

    var compare = document.querySelector('[data-sw-compare]');
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (state.projet && c.getAttribute('data-uses').indexOf('|' + state.projet + '|') < 0) ok = false;
        if (ok && state.type.length && state.type.indexOf(c.getAttribute('data-type')) < 0) ok = false;
        if (ok && state.h.length && !state.h.some(function (h) { return c.getAttribute('data-h').indexOf('|' + h + '|') >= 0; })) ok = false;
        if (ok && state.o.length && state.o.indexOf(c.getAttribute('data-open')) < 0) ok = false;
        if (ok && state.stock && c.getAttribute('data-avail') !== 'true') ok = false;
        c.hidden = !ok; if (ok) shown++;
        if (compare) $$('[data-sw-col="' + c.getAttribute('data-pid') + '"]', compare).forEach(function (td) { td.hidden = !ok; });
      });
      count.textContent = shown + ' ' + (shown > 1 ? t('produits', 'products') : t('produit', 'product'));
      $$('[data-sw-count-n]', root).forEach(function (n) { n.textContent = shown; });
      empty.hidden = shown > 0;
      try {
        var u = new URL(location.href);
        ['projet', 'type', 'hauteur'].forEach(function (k) { u.searchParams.delete(k); });
        if (state.projet) u.searchParams.set('projet', state.projet);
        if (state.type.length) u.searchParams.set('type', state.type.join(','));
        if (state.h.length) u.searchParams.set('hauteur', state.h.join(','));
        history.replaceState({}, '', u);
      } catch (e) {}
    }
    function sort(by) {
      var list = cards.slice().sort(function (a, b) {
        if (by === 'ppf') return (+a.getAttribute('data-ppf') || 1e9) - (+b.getAttribute('data-ppf') || 1e9);
        if (by === 'open') return (+a.getAttribute('data-open') || 1e9) - (+b.getAttribute('data-open') || 1e9);
        return +a.getAttribute('data-pop') - +b.getAttribute('data-pop');
      });
      list.forEach(function (c) { grid.appendChild(c); });
    }
    function setProjet(handle) {
      state.projet = handle;
      $$('[data-sw-proj]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-sw-proj') === handle)); });
      var b = handle ? $('[data-sw-proj="' + handle + '"]', root) : null;
      if (b && (b.getAttribute('data-advice') || b.getAttribute('data-notfor'))) {
        var nf = b.getAttribute('data-notfor');
        advice.innerHTML = '';
        var strong = document.createElement('b'); strong.textContent = b.getAttribute('data-label') || b.textContent.trim();
        advice.appendChild(strong);
        advice.appendChild(document.createTextNode(' : ' + b.getAttribute('data-advice') + (nf ? ' ' + nf : '')));
        advice.hidden = false;
      } else advice.hidden = true;
      cards.forEach(function (c) {
        var el = $('[data-sw-rec]', c); if (!el) return;
        var m = handle ? (c.getAttribute('data-rec') || '').match(new RegExp('\\|' + handle.replace(/[-]/g, '\\-') + '=([^|]+)')) : null;
        el.hidden = !m; if (m) el.textContent = (data.recLabel || '') + ' : ' + m[1];
      });
      apply();
    }
    $$('[data-sw-proj]', root).forEach(function (b) {
      b.addEventListener('click', function () { setProjet(state.projet === b.getAttribute('data-sw-proj') ? '' : b.getAttribute('data-sw-proj')); });
    });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-sw-f]'); if (!c) return;
      var k = c.getAttribute('data-sw-f'), v = c.getAttribute('data-v');
      var on = c.getAttribute('aria-pressed') !== 'true';
      c.setAttribute('aria-pressed', String(on));
      if (k === 'stock') state.stock = on;
      else if (on) state[k].push(v); else state[k] = state[k].filter(function (x) { return x !== v; });
      apply();
    });
    var reset = $('[data-sw-reset]', root);
    if (reset) reset.addEventListener('click', function () {
      state = { projet: '', type: [], h: [], o: [], stock: false };
      $$('[aria-pressed="true"]', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      $$('[data-sw-rec]', root).forEach(function (el) { el.hidden = true; });
      advice.hidden = true; apply();
    });
    var sel = $('[data-sw-sort]', root);
    if (sel) sel.addEventListener('change', function () { sort(sel.value); });
    // Filters: a bottom sheet on phones (closed by the backdrop or "Voir les produits"); on wider screens the bar
    // sticks just below the theme's sticky header.
    var tog = $('[data-sw-filters-toggle]', root), bar = $('[data-sw-filters]', root), backdrop = $('[data-sw-filters-backdrop]', root);
    function setSheet(o) {
      bar.classList.toggle('is-open', o); if (tog) tog.setAttribute('aria-expanded', String(o));
      if (backdrop) backdrop.hidden = !o;
      document.documentElement.classList.toggle('sw-sheet-open', o);
    }
    if (tog) tog.addEventListener('click', function () { setSheet(!bar.classList.contains('is-open')); });
    if (backdrop) backdrop.addEventListener('click', function () { setSheet(false); });
    var done = $('[data-sw-filters-done]', root);
    if (done) done.addEventListener('click', function () {
      setSheet(false);
      window.scrollTo({ top: Math.max(0, grid.getBoundingClientRect().top + window.pageYOffset - 80), behavior: 'smooth' });
    });
    function stickyTop() {
      var h = 0;
      $$('.shopify-section-group-header-group, sticky-header').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') h = Math.max(h, Math.round(el.getBoundingClientRect().bottom));
      });
      bar.style.setProperty('--sw-sticky-top', Math.max(0, h) + 'px');
    }
    var stTick = null;
    stickyTop(); window.addEventListener('resize', stickyTop);
    window.addEventListener('scroll', function () { if (stTick) return; stTick = requestAnimationFrame(function () { stTick = null; stickyTop(); }); }, { passive: true });

    // "Choisir par type": filter the list by that type and bring it into view.
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sw-type-pick]'); if (!b) return;
      var v = b.getAttribute('data-sw-type-pick');
      state.type = [v];
      $$('[data-sw-f="type"]', root).forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-v') === v)); });
      apply();
      var y = grid.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });

    // URL presets
    try {
      var p = new URL(location.href).searchParams;
      (p.get('type') || '').split(',').filter(Boolean).forEach(function (v) { var c = $('[data-sw-f="type"][data-v="' + v + '"]', root); if (c) { c.setAttribute('aria-pressed', 'true'); state.type.push(v); } });
      (p.get('hauteur') || '').split(',').filter(Boolean).forEach(function (v) { var c = $('[data-sw-f="h"][data-v="' + v + '"]', root); if (c) { c.setAttribute('aria-pressed', 'true'); state.h.push(v); } });
      if (p.get('projet') && $('[data-sw-proj="' + p.get('projet') + '"]', root)) { setProjet(p.get('projet')); return bindCollCalc(); }
    } catch (e) {}
    apply();
    bindCollCalc();

    function bindCollCalc() {
      var box = $('[data-sw-calc-coll]', root); if (!box) return;
      var pSel = $('[data-sw-calc-p]', box), hSel = $('[data-sw-calc-h]', box);
      if (!pSel || !pSel.options.length) { box.hidden = true; return; }
      function fillHeights() {
        var d = data.products[pSel.value]; if (!d) return;
        var seen = {}; hSel.innerHTML = '';
        d.variants.forEach(function (v) { if (v.h && !seen[v.h]) { seen[v.h] = 1; } });
        Object.keys(seen).map(Number).sort(function (a, b) { return a - b; }).forEach(function (h) {
          var o = document.createElement('option'); o.value = h; o.textContent = heightLabel(h, d.inch); hSel.appendChild(o);
        });
        if (box.__swRender) box.__swRender();
      }
      bindCalc(box, function () { return data.products[pSel.value]; }, fmt);
      pSel.addEventListener('change', fillHeights);
      fillHeights();
    }
  }

  function boot() {
    $$('[data-sw-product]').forEach(initProduct);
    $$('[data-sw-coll]').forEach(initCollection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
